import { Component, Input } from '@angular/core';
import { IVerifyCodeRequest } from '../../../../../classes/http-requests';


@Component({
    selector: 'validate-code',
    template: require('./validate-code.component.html')
})

export class ValidateCodeComponent {
    @Input() verfiyCodeRequest: IVerifyCodeRequest;

    constructor() {
        
    }
}
